import serviceNowImage from './images/serviceNow.png'
import dashboardImage from './images/dashbord.png'
import qualysImage from './images/qualys.png'
import qradar from './images/qradar.png'
import point from './images/proofPoint.png'
import crow from './images/crowdstrike.png'
import mcafee from './images/mcafee.png'
import resilient from './images/resilient.png'
import tableau from './images/tableau.png'
import power from './images/power-bi.png'
import sumoLogic from './images/sumoLogic.png'
import bmcFootprints from './images/BMCFootprints.png'


export default [
  { name: 'Dashboard', link: 'dashboard', image: dashboardImage},
  { name: 'Qualys', link: 'qualys', image: qualysImage},
  { name: 'Service Now', link: 'service-now', image: serviceNowImage},
  { name: 'Sumo Logic', link: 'sumo-logic', image: sumoLogic },
  { name: 'BMC Footprints', link: 'dashboard', image: bmcFootprints },
  { name: 'IBM QRadar', link: 'dashboard', image: qradar},
  { name: 'Proof Point', link: 'dashboard', image: point},
  { name: 'Crowdstrike', link: 'dashboard', image: crow},
  { name: 'Mcafee', link: 'dashboard', image: mcafee},
  { name: 'IBM Resilient', link: 'dashboard', image: resilient},
  { name: 'Tableau', link: 'dashboard', image: tableau},
  { name: 'Power Bi', link: 'dashboard', image: power},
]